import Component from 'vue-class-component';
import ContentComponents from '@/content/components/content-components';
import Form from '@/components/form/form';
import Common from '@/components/common/common';
import EdObjectPreview from '@/content/pages/create-lesson/routes/ed-object-preview/ed-object-preview.vue'
import Course from '@/content/models/course.model';
import { SectionsProvider } from '@/content/providers/sections.provider';
import { CourseToolsMixin } from '@/courses/mixins/course-tools.mixin';
import { Status } from '@/models/status.model';
import { COMPONENT_TYPE } from '@/courses/values/courses.values';
import KEYS from '@/values/keys';
import { PREFERENCES_STORE } from '@/preferences/values/preferences.values';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import EdLessonCreator from '@/content/pages/create-lesson/routes/ed-lesson-creator/ed-lesson-creator.vue';
import EdSectionMaterialCreator from '@/content/pages/create-lesson/routes/ed-section-material-creator/ed-section-material-creator.vue';
import EdProjectCreator from '@/content/pages/create-lesson/routes/ed-project-creator/ed-project-creator.vue';
import { Mixins, Prop } from 'vue-property-decorator';
import { COURSE_MODE } from '@/courses/enums/course-edition.enum';
import { APP_STORE } from '@/core/store/app.store';
import EdContentSidebarOpenArrow from '@/content/components/ed-content-sidebar-open-arrow/ed-content-sidebar-open-arrow.component.vue';
import { SectionSchooolCalendarProvider } from '@/sections/providers/section-school-calendar.provider';
import { ContentType } from '@/content/types/content.types';
import EdDeckLibraryCreator from '@/courses/components/flash-cards/ed-deck-library-creator/ed-deck-library-creator.vue';
import EdDeckViewerContainer from '@/courses/components/flash-cards/ed-deck-viewer-container/ed-deck-viewer-container.component.vue';

@Component({
  name: 'ed-subject-builder-editor',
  components: {
    Common,
    ...Form,
    ...ContentComponents,
    EdObjectPreview,
    EdLessonCreator,
    EdSectionMaterialCreator,
    EdProjectCreator,
    EdContentSidebarOpenArrow,
    EdContentSubjectCalendar: () => import(/* EdContentSubjectCalendar */'@/courses/components/ed-content-subject-calendar/ed-content-subject-calendar.component.vue'),
    EdDeckLibraryCreator,
    EdDeckViewerContainer,
  }
})
export default class EdSubjectBuilderEditorComponent extends Mixins(CourseToolsMixin) {

  @Prop() readonly courseId: number;
  @Prop({ default: false }) readonly showBuilderData: boolean;

  public status: Status = new Status();
  public mode: COURSE_MODE = COURSE_MODE.EDIT;
  public isPurchasedTemplate: boolean = false;
  public contentType: ContentType = 'SUBJECT';

  get isTemplate() {
    return this.contentType === 'TEMPLATE';
  }

  get institutionsLoaded() {
    return this.$store.state.AppStore.institutionsLoaded;
  }

  get course(): any {
    return this.getCourseFromStore({ courseId: this.courseId });
  }

  get hasObjectSelected () {
    return this.$store.state.CourseStore.hasObjectSelected
  }

  get viewer() {
    if (this.course) {
      const componentName = this.course.component.name;

      if (COMPONENT_TYPE[componentName]) {
        return COMPONENT_TYPE[componentName].viewer;
      }
    }
    return null;
  }

  get isStudentOrSubstituteWithoutPermissions() {
    const isStudent = this.$store.getters['AuthStore/isStudent'];
    const isSubstituteTeacher = this.$store.getters['AuthStore/isSubstituteTeacher'];
    const isSubstituteTeacherWithoutPermissions = isSubstituteTeacher && this.course?.classId && !this.$store.state.ClassesStore.substituteTeacherCanEditClass.get(this.course?.classId);

    return isStudent || (isSubstituteTeacher && isSubstituteTeacherWithoutPermissions);
  }

  get isAuthor() {
    return this.$store.getters['AuthStore/isAuthor'];
  }

  get isSidebarClosed() {
    return !this.$store.state.AppStore.sidebarShown;
  }

  get minDate() {
    let minDate = '';
    if(this.course) {
      minDate = this.course.component ? this.course.component.minDate : '';
    }
    return minDate;
  }

  get isSubjectFromTemplate() {
    if (!this.isTemplate) {
      return this.course?.origin === 'BUILDER' && Number(this.course.builderVersion) !== 3;
    }

    return false;
  }

  setInitSection() {
    let sections = this.course.sections;
    let sectionToLoad;
    let $root: any = this.$root;
    if(sections.length > 0) {
      let storageSectionId = localStorage.getItem('sectionId');
      let filterSections = sections.filter(section => {
        if(section.id==storageSectionId)
          return section;
      });
      if(filterSections && storageSectionId) {
        sectionToLoad = storageSectionId;
      } else if($root.idSectionToLoad === -1) {
        sectionToLoad = sections[0].sectionId
      } else {
        let sectionFromProvider = SectionsProvider.getSectionById(this.course.sections, $root.idSectionToLoad);
        sectionToLoad = sectionFromProvider == null ? sections[0].sectionId : sectionFromProvider.value.sectionId;
      }
      if (sectionToLoad) {
        this.goToSectionPreview({sectionId: sectionToLoad , courseId: this.courseId});
      }
    }
  }

  async setCourseData() {
    try {
      this.status.setLoading();
      if(!this.institutionsLoaded) {
        this.$store.subscribe((mutation) => {
          if(mutation.type == APP_STORE.MUTATIONS.SET_INSTITUTIONS_LOADED) {
            this.status.setLoad();
            this.setInitSection();
          }
        });
      } else {
        this.status.setLoad();
        this.setInitSection();
      }
    } catch(err) {
      this.status.setError();
    }
  }

  onModeChanged(mode) {
    this.mode = mode;
  }

  toggleSidebar() {
    this.$App.Store.toggleSidebar()
  }

  async setSchoolCalendar() {
    if(this.course.schoolCalendar) {
      SectionSchooolCalendarProvider.schoolDays = this.course.schoolCalendar;
      if(!this.isTemplate) {
        SectionSchooolCalendarProvider.preferences = this.$store.state.SchoolCalendarStore.preferences;
      } else {
        SectionSchooolCalendarProvider.holidays = this.$store.state.SchoolCalendarStore.holidays;
        SectionSchooolCalendarProvider.preferences = this.$store.state.SchoolCalendarStore.preferences;
      }
    } else {
      SectionSchooolCalendarProvider.schoolDays = { dates: [] };
      SectionSchooolCalendarProvider.holidays = [];
      SectionSchooolCalendarProvider.preferences = [];
    }
  }

  created() {
    //this.$Courses.Store.setCourseInfo(new Course({ id: this.courseId}));
  }

  async mounted() {
    this.setCourseData();
    this.$edEventBus.$on(COURSES_EVENTS.REFRESH_WIDGET_COURSE, this.setCourseData);
  }
}
